import React, { useMemo, useState } from 'react';
import { PopoverOption } from '../../../../shared/PopoverMenu';
import { useTree } from './map-helpers/hooks/useTree';
import { JunctionTreeNode, PumpTreeNode, TreeNodeType } from './treeNode';
import { ReactComponent as DeleteIcon } from '../../../../images/icons/delete.svg';
import { Popover } from './Popover';

type Props = {
  node?: PumpTreeNode | JunctionTreeNode;
  replaceWithFirstChild?: boolean;
};

export const DeletePopover = ({ node, replaceWithFirstChild }: Props) => {
  const [tooltipLabel, setTooltipLabel] = useState<string>('');
  const { smartMarkNodeForRemoval, deleteEntryAndReconnectChildren, unmarkForDeletionAllNodes } = useTree();

  useMemo(() => {
    setTooltipLabel(
      node?.nodeType === TreeNodeType.Junction ? 'Remove this downstream section of the junction' : 'Remove pump',
    );
  }, [node]);

  if (!node) {
    return null;
  }

  const handleMarkForDelete = () => {
    smartMarkNodeForRemoval(node, replaceWithFirstChild);
  };

  const handleDelete = () => {
    deleteEntryAndReconnectChildren(node, replaceWithFirstChild);
  };

  const handleUnmark = () => {
    unmarkForDeletionAllNodes();
  };

  const options: Array<PopoverOption> = [
    { name: 'Confirm Delete', onClick: handleDelete, icon: 'Tick', dataTestId: '' },
    { name: 'Cancel', onClick: handleUnmark, icon: 'Cross', dataTestId: '' },
  ];

  return (
    <>
      <Popover
        tooltipLabel={tooltipLabel}
        icon={<DeleteIcon title={tooltipLabel} />}
        options={options}
        onClickAway={handleUnmark}
        onMenuOpen={handleMarkForDelete}
      />
    </>
  );
};
